import { useEffect, useState } from "react";

const KEY = "klt_mode";
export const getMode = () => (localStorage.getItem(KEY) === "atelier" ? "atelier" : "salon");

export function setMode(m) {
  localStorage.setItem(KEY, m);
  window.dispatchEvent(new CustomEvent("klt:mode", { detail: m }));
}

export function useMode() {
  const [mode, setM] = useState(getMode);
  useEffect(() => {
    const h = () => setM(getMode());
    window.addEventListener("klt:mode", h);
    return () => window.removeEventListener("klt:mode", h);
  }, []);
  return [mode, setMode];
}
